import { useState } from 'react';
import './Home.css';

function Home() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent('KeepOrDel – Contact from website');
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`
    );
    window.location.href = `mailto:baralnishan987@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="home">
      <section className="hero">
        <h1 className="app-name">KeepOrDel</h1>
        <p className="tagline">Sort your gallery—swipe to keep or delete.</p>
      </section>

      <section className="app-info section">
        <h2>About the App</h2>
        <p>
          KeepOrDel is a fully <strong>offline</strong> app. There is no login—your photos never leave your device.
          With your permission, the app accesses your photo gallery so you can quickly sort through them.
        </p>
        <ul className="feature-list">
          <li><strong>Swipe right</strong> to keep a photo.</li>
          <li><strong>Swipe left</strong> to delete it.</li>
        </ul>
        <p>Use KeepOrDel to declutter your camera roll and keep only the photos that matter.</p>
      </section>

      <section className="screenshots section">
        <h2>Screenshots</h2>
        <div className="screenshot-grid">
          <div className="screenshot-item">
            <img src="/assets/left.jpg" alt="KeepOrDel – swipe left to delete" />
            <span>Swipe left to delete</span>
          </div>
          <div className="screenshot-item">
            <img src="/assets/right.jpg" alt="KeepOrDel – swipe right to keep" />
            <span>Swipe right to keep</span>
          </div>
        </div>
      </section>

      <section className="developer section">
        <h2>Developer</h2>
        <div className="developer-card">
          <p><strong>Name:</strong> Nishan Baral</p>
          <p><strong>Email:</strong>{' '}
            <a href="mailto:baralnishan987@gmail.com">baralnishan987@gmail.com</a>
          </p>
        </div>
      </section>

      <section className="contact section">
        <h2>Get in Touch</h2>
        <p className="contact-intro">
          Have questions about KeepOrDel? We'd love to hear from you!
        </p>
        <p className="contact-sub">Share your feedback or reach out to our team.</p>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label htmlFor="name">Name:</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name"
              required
            />
          </div>
          <div className="form-row">
            <label htmlFor="email">Email:</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
            />
          </div>
          <div className="form-row">
            <label htmlFor="message">Message:</label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Your message..."
              rows={5}
              required
            />
          </div>
          <div className="form-actions">
            <button type="submit" className="btn-send">Send</button>
          </div>
        </form>
      </section>
    </div>
  );
}

export default Home;
